import script from "./CatalogListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogListItem.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogListItem.vue?vue&type=style&index=0&id=7a1450ec&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a1450ec"]])

export default __exports__